<template>
  <div class="evaluation-empty">
    <img src="~@/assets/images/exam/empty.png" alt />
    <div class="text">
      <span>{{ text }}</span>
      <span v-if="showBtn">，</span>
      <el-button
        v-if="showBtn"
        type="text"
        @click="$router.push({ name: 'ExamIndex' })"
      >
        快去练习
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluationEmpty",
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
    showBtn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation-empty {
  // text-align: center;
  position: relative;
  padding: 150px 0;
  height: 356px;
  img {
    width: 484px;
    position: absolute;
    left: 50%;
    transform: translateX(calc(-50% - 15px));
  }
  .text {
    color: #666;
    font-size: 16px;
    position: absolute;
    left: 50%;
    top: 390px;
    transform: translateX(-50%);
    .el-button--text {
      font-size: 16px;
    }
  }
}
</style>
